<template>
    <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
        <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
            <div class="container" v-bind:style="ContainerPadding">
                <div class="">

                    <!-- End Heading -->
                    <div class="row row-cols-1 row-cols-lg-2 justify-content-center">
                        <div class="col" v-if="FieldInspectionConfig.offerResidentialOccupied || FieldInspectionConfig.offerResidentialUnoccupied">
                            <div :style="{'background-color' : BlockProps.HighlightColor + ' !important'}" class="mb-6 shadow-sm p-3 rounded-2">

                                <h1 :style="{'color': BlockProps.TextColor}"><i class="bi-house-door" :style="{'color': BlockProps.IconColor}"></i> Residential</h1>
                                <p :style="{'color': BlockProps.TextColor}" class="small" v-if="!FieldInspectionConfig.offerResidentialOccupied">*Excludes interiors of occupied locations</p>
                                <p :style="{'color': BlockProps.TextColor}" class="small" v-else-if="!FieldInspectionConfig.offerResidentialUnoccupied">*Excludes interiors of unoccupied locations</p>
                                <p class="small" v-else>&nbsp;</p>
                            </div>

                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="BlockProps.ResidentialContent" tag-name="div" :init="EditorConfig" />
                            <!-- End List -->



                        </div>
                        <!-- End Col -->

                        <div class="col" v-if="FieldInspectionConfig.offerCommercial">
                            <div :style="{'background-color' : BlockProps.HighlightColor + ' !important'}" class="mb-6 shadow-sm p-3 rounded-2">
                                <h1 :style="{'color': BlockProps.TextColor}"><i class="bi-bank" :style="{'color': BlockProps.IconColor}"></i> Commercial</h1>
                                <p :style="{'color': BlockProps.TextColor}" class="small" v-if="!FieldInspectionConfig.offerIndustrial">*Excludes industrial sites</p>
                                <p class="small" v-else>&nbsp;</p>
                            </div>
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="BlockProps.CommercialContent" tag-name="div" :init="EditorConfig" />

                            <!-- End List -->
                            <!-- End Row -->
                        </div>
                        <!-- End Col -->

                        <div class="col" v-if="FieldInspectionConfig.offerIndustrial">
                            <div :style="{'background-color' : BlockProps.HighlightColor + ' !important'}" class="mb-6 shadow-sm p-3 rounded-2">
                                <h1 :style="{'color': BlockProps.TextColor}"><i class="bi-gear-wide-connected" :style="{'color': BlockProps.IconColor}"></i> Industrial</h1>
                                <p class="small">&nbsp;</p>
                            </div>
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="BlockProps.IndustrialContent" tag-name="div" :init="EditorConfig" />

                            <!-- End List -->
                            <!-- End Row -->
                        </div>
                        <!-- End Col -->

                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <omnieditor :iseditmode="iseditmode" editortype="tinymce" class="small" keyDown v-model="BlockProps.Footer" tag-name="div" :init="EditorConfig" />
                        </div>
                        <!-- End Row -->
                    </div>
                </div>

            </div>

        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>
                        <propertycoloreditor :propertyname="'IconColor'" :blockprops="BlockProps" :prompt="'Icon Color'"></propertycoloreditor>
                        <propertycoloreditor :propertyname="'TextColor'" :blockprops="BlockProps" :prompt="'Text Color'"></propertycoloreditor>
                        <propertycoloreditor :propertyname="'HighlightColor'" :blockprops="BlockProps" :prompt="'Highlight Color'"></propertycoloreditor>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'


    export default {
        inheritAttrs: false,
        name: 'InspectionFeatures',
        mixins: [ContentBlockBase],
        props: ['fieldinspectionconfig'],
        components: {

        },
        computed:
        {           
            FieldInspectionConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.fieldinspectionconfig) {
                    return this.fieldinspectionconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig.serviceConfigFieldInspection) {
                    return this.Store.TenantConfig.serviceConfigFieldInspection;
                }
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#FieldInspectionSettings'
            };
        },
        watch: {
          
        },
        methods:
        {
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            
        },
        beforeUnmount()
        {
            
        },
        mounted() {
            nextTick().then(() => {
         
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>

